import type { ComponentProps, ReactNode } from 'react';
import { Button } from '../ui/button';
import { useFormContext } from './form-context';

export function FormSubmitButton({
  children,
  className,
  ...buttonProps
}: {
  children: ReactNode;
  className?: string;
} & ComponentProps<typeof Button>) {
  const form = useFormContext();

  return (
    <form.Subscribe
      selector={(state) => [state.isSubmitting]}
      children={([isSubmitting]) => (
        <Button
          type="submit"
          isLoading={isSubmitting || buttonProps.isLoading}
          variant="secondary"
          {...buttonProps}
          className={className}
        >
          {isSubmitting ? 'Submitting...' : children}
        </Button>
      )}
    />
  );
}
